module.exports = __webpack_public_path__ + "static/media/tip-modal-sub-title.0a134b4c.png";